export const breakpoints = {
  huge: "1440px",
  large: "1024px",
  medium: "768px",
  small: "450px",
};
